define((require) => {
    "use strict";

    const
        ImprovedView                        = require("editor/zbone/ImprovedView"),
        template                            = require("ui/editor/email/PopupMessageView.tpl");


    /**
     * Component representing content for the <tt>RemoveIncompatibleWidgetsView</tt>.
     *
     *
     * @class RemoveIncompatibleWidgetsContentView
     *
     */
    return ImprovedView.extend({
        template,

        ui: {
            customBody: ".custom-body"
        },

        onRender() {
            const content = "Widgets to be removed: " + this.model.get("widgetsName");
            this.ui.customBody.html(content);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/PopupMessageView.js